import { Helpers } from '../../helpers';
import { IPerforatingScheme } from '../../interfaces/iperforating-scheme';
import { CompletionDesign } from '../completion-design';

export class PerforatingSchemeBase {
  PerforatingSchemeId: number;
  Description: string | null;
  Abbreviation: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CompletionDesigns_PerforatingScheme?: Array<CompletionDesign> | null;

  constructor(item?: IPerforatingScheme) {
    if (item) {

      this.PerforatingSchemeId = item.PerforatingSchemeId;
      this.Description = item.Description;
      this.Abbreviation = item.Abbreviation;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CompletionDesigns_PerforatingScheme = Helpers.createClassArray(CompletionDesign, item.CompletionDesigns_PerforatingScheme);
    }
  }
}